// https://vuex.vuejs.org/en/getters.html

export default {
  getSubscriptionsStatusColor: state => subscriptions => {
    if (subscriptions.status === 'processing') {
      return 'grey'
    }
    if (subscriptions.status === 'updating') {
      return 'info'
    }

    if (subscriptions.type === 'Flex') {
      return 'succes'
    }

    // todo dateTimeCalculations
    if (subscriptions.expireDate < 'this should be a date within a month') {
      return 'warning'
    }

    return 'error'
  },
}
